import React, { useState, useEffect } from "react";
import StatusNew from "../../telerik-tasks/common-components/status-new";
import { TaskActions } from "../../telerik-tasks/common-components/task-actions";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import { getTaskWithWorkflow } from "../../../../../services/api/task-api";
import { Skeleton } from "@progress/kendo-react-indicators";
import "./task-edit-header.scss";
import PropTypes from 'prop-types';

const TaskEditHeader = ({
  task,
  taskName,
  refreshStatus,
  setRefreshStatus,
  GetTask,
  scrollToSection,
  refs,
  isView,
  labels
}) => {
  const [taskWorkflow, setTaskWorkflow] = useState(task);

  useEffect(() => {
    if (refreshStatus) {
      const fetchTaskWorkflow = async () => {
        let result = await getTaskWithWorkflow(task.Id);
        setTaskWorkflow({ ...result, isWorkflow: true });
        setRefreshStatus(false);
      };
      fetchTaskWorkflow();
    }
  }, [refreshStatus]);

  return (
    <div className="task-edit-header">
      <div className="task-edit-header-content">
        <div className="task-edit-heading">{ isView? "View" : "Edit"} {labels?.TaskSingular ?? 'Task'}</div>
        <div className="task-edit-task-name">{taskName}</div>
      </div>

      <div className="task-edit-header-top">
        <div className="task-status-actions">
          {refreshStatus ? (        
            <Skeleton
              shape="rectangle"
              className="skeleton-button-tasklist"
              style={{ width: "75px", height: "30px", borderRadius: "4px" }}
            />
          ) : (
            <StatusNew
              status={
                    taskWorkflow.WorkflowStatus !== null || taskWorkflow.StatusId === 3 || taskWorkflow.isArchived
                    ? taskWorkflow?.DisplayStatus ?? taskWorkflow?.StatusAndButtons?.Status ?? ""
                    : taskWorkflow?.StatusAndButtons?.Status ?? ""
                  }
            />
          )}
          <div className="td-actions">
            <TaskActions
              taskId={task.Id}
              refreshTasks={() => GetTask(task.Id)}
              setTaskWorkflow={setTaskWorkflow}
              setRefreshStatus={setRefreshStatus}
              fromTaskEdit={true}
            />
          </div>
        </div>
        <div className="task-navigation">
          <FluentButton
            appearance="secondary"
            text={`${labels?.TaskSingular ?? 'Task'} Details`}
            onClick={() => scrollToSection(refs.taskDetailsRef)}
            icon={<FluentUiIcon name={"AppsListDetailRegular"} color={"#0F6CBD"} size={20} />}
          />
          <FluentButton
            appearance="secondary"
            text={`${labels?.TaskSingular ?? 'Task'} ${labels?.FormPlural ?? 'Forms'}`}
            onClick={() => scrollToSection(refs.taskFormAssignMembersRef)}
            icon={<FluentUiIcon name={"FormRegular"} color={"#0F6CBD"} size={20} />}
          />
          <FluentButton
            appearance="secondary"
            text="Assigned Members"
            onClick={() => scrollToSection(refs.taskFormAssignMembersRef)}
            icon={<FluentUiIcon name={"PeopleRegular"} color={"#0F6CBD"} size={20} />}
          />
          <FluentButton
            appearance="secondary"
            text="Audit Trail"
            onClick={() => scrollToSection(refs.auditTrailRef)}
            icon={<FluentUiIcon name={"ClipboardTextLtrRegular"} color={"#0F6CBD"} size={20} />}
          />
          <FluentButton
            appearance="secondary"
            text="Actions"
            onClick={() => scrollToSection(refs.actionsRef)}
            icon={<FluentUiIcon name={"ArrowRotateClockwiseRegular"} color={"#0F6CBD"} size={20} />}
          />
        </div>
      </div>
    </div>
  );
};

TaskEditHeader.propTypes = {
  task: PropTypes.object.isRequired,
  taskName: PropTypes.string.isRequired,
  refreshStatus: PropTypes.bool.isRequired,
  setRefreshStatus: PropTypes.func.isRequired,
  GetTask: PropTypes.func.isRequired,
  scrollToSection: PropTypes.func.isRequired,
  refs: PropTypes.object.isRequired,
  isView: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
      ProjectSingular: PropTypes.string,
      ProjectPlural: PropTypes.string,
      ProjectSingularPossessive: PropTypes.string,
      ProjectPluralPossessive: PropTypes.string,
      TaskSingular: PropTypes.string,
      TaskPlural: PropTypes.string,
      TaskSingularPossessive: PropTypes.string,
      TaskPluralPossessive: PropTypes.string,
      FormSingular: PropTypes.string,
      FormPlural: PropTypes.string,
      FormSingularPossessive: PropTypes.string,
      FormPluralPossessive: PropTypes.string,
  }),
};

export default TaskEditHeader;
